import React from 'react'
import TableLayout from './TableLayout.js'
import TileLayout from './TileLayout.js'

class ServicesContainer extends React.Component {
  constructor(props) {
    super(props)
  }

  handleRemoveItem(e) {
    e.preventDefault()
    const service = e.target.getAttribute('value')
    this.props.updateServices(service, true)
  }

  render() {
    if(this.props.layout == 'tile') {
      return <TileLayout servicesToCompare={this.props.servicesToCompare}
                  handleRemoveItem={this.handleRemoveItem.bind(this)}
                  filterKey={this.props.filterKey}
                  fields={this.props.fields}
                  tileFieldCount={this.props.tileFieldCount}
                  accessLevel={this.props.accessLevel}
                  lowestMonthlyPrice={this.props.lowestMonthlyPrice}
                  {...this.props} />
    } else if(this.props.layout == 'table') {
      return <TableLayout servicesToCompare={this.props.servicesToCompare}
                          handleRemoveItem={this.handleRemoveItem.bind(this)}
                          filterKey={this.props.filterKey}
                          fields={this.props.fields}
                          updateScrollPosition={this.props.updateScrollPosition}
                          scrollPosition={this.props.scrollPosition}
                          maxScrollPosition={this.props.maxScrollPosition}
                          tableFieldCount={this.props.tableFieldCount}
                          accessLevel={this.props.accessLevel}
                          {...this.props} />
    }
  }
}

export default ServicesContainer
